import React, { Ref, useEffect, useState } from 'react';
import { css } from 'emotion';
import { darken } from 'polished';
import Tracking from '@vromo/analytics';
import FadeIn from '@vromo/ui/components/FadeIn';
import { observer } from 'mobx-react-lite';
import { Theme } from '@emotion/react';
import { Vehicle } from '@vromo/models';
import { secrets } from '@vromo/api';

interface TipWidgetProps {
    theme: Theme;
    vehicle?: Vehicle;
}

/** Tip driver widget ( money sent to paypal) */
export const TipWidget = observer<TipWidgetProps>(
    ({ theme, vehicle }, ref: Ref<HTMLDivElement>) => {
        const [currency, setCurrency] = useState<string>('USD');

        useEffect(() => {
            (async () => {
                try {
                    const fetchResponse = await fetch(secrets.ipstack);
                    const ipStackData = await fetchResponse.json();
                    setCurrency(ipStackData.currency.code);
                } catch (err) {
                    console.log('Error getting ipStack currency: ', err);
                }
            })();
        }, []);

        if (!currency || !vehicle?.driver?.payment?.paypal) {
            console.error(`vehicle driver '${vehicle?.id}' doesnt have any paypal account setup`);
            return null;
        }
        return (
            <FadeIn>
                <div ref={ref!} style={{ textAlign: 'center', marginBottom: 24 }}>
                    <div
                        className={css`
                            font-size: 20px;
                            color: #111111;
                            font-weight: 400;
                        `}>
                        Add a tip for your driver
                    </div>
                    <div
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            display: currency ? 'flex' : 'none'
                        }}>
                        {[1, 2, 5].map((amount) => (
                            <a
                                key={amount}
                                rel="noopener noreferrer"
                                target="_blank"
                                // we have previously verified that tere is a paypal address
                                href={`https://paypal.me/${
                                    vehicle!.driver!.payment!.paypal
                                }/${amount.toFixed(2)}`}
                                onClick={() => Tracking.track('Tip Widget Clicked', { amount })}
                                className={css`
                                    border-radius: 50%;
                                    width: 56px;
                                    height: 56px;
                                    margin: 8px;
                                    background-color: ${theme.accent};
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    text-decoration: none;
                                    font-weight: bold;
                                    color: #474747;
                                    cursor: pointer;
                                    font-size: 14px;

                                    &:hover,
                                    &:focus {
                                        background-color: ${darken(0.02, theme.accent)};
                                    }
                                `}>
                                {amount.toLocaleString(navigator.language, {
                                    style: 'currency',
                                    currency,
                                    currencyDisplay: 'symbol'
                                })}
                            </a>
                        ))}
                    </div>
                    <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={`https://paypal.me/${vehicle.driver.payment.paypal}`}
                        style={{ color: '#111111', textDecoration: 'none' }}>
                        Enter a custom amount
                    </a>
                </div>
            </FadeIn>
        );
    },
    { forwardRef: true }
);
